import { ClientAccountNumberStep } from "./steps/ClientAccountNumberStep";
import { EmailAddressStep } from "./steps/EmailAddressStep";
import { EmailVerificationCodeStep } from "./steps/EmailVerificationCodeStep";
import { AddAccountFormSteps, AddAccountStepProps } from "./steps/StepModel";
import { SuccessStep } from "./steps/SuccessStep";

export const AddAccountStep: React.FC<AddAccountStepProps> = (props: AddAccountStepProps) => {
  switch (props.currentStep) {
    case AddAccountFormSteps.ClientAccountNumber:
      return <ClientAccountNumberStep {...props} />;
    case AddAccountFormSteps.EmailAddress:
      return <EmailAddressStep {...props} />;
    case AddAccountFormSteps.EmailVerificationCode:
      return <EmailVerificationCodeStep {...props} />;
    case AddAccountFormSteps.Success:
      return <SuccessStep />;
    default:
      return <></>;
  }
};
